import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// const gitlabBaseUrl = 'http://127.0.0.1:8002/api/1.0/gitlab/'
// 持续发布基础URL
const baseDeployUrl = config.baseDeployUrl
const gitlabBaseUrl = baseDeployUrl + '/api/1.0/gitlab/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getGitlabGroupList = () => {
  return axios.request({
    url: gitlabBaseUrl + 'group/list',
    headers: baseHeaders,
    method: 'get'
  })
}
